import { apiRequest } from "./client";

export const getTemplates = async () => {
  const response = await apiRequest(`/api/v1/templates`);
  if (!response.ok) {
    throw new Error("テンプレートの取得に失敗しました");
  }
  return await response.json();
};

export const createTodos = async (data) => {
  const response = await apiRequest(`/api/v1/todos`, {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error("ワースケの作成に失敗しました");
  }
  return await response.json();
};

export const createChecklist = async (data) => {
  const response = await apiRequest(`/api/v1/checklists`, {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error("チェックリストの作成に失敗しました");
  }
  return await response.json();
};

export const deleteTemplate = async (templatePublicId) => {
  const response = await apiRequest(`/api/v1/templates/${templatePublicId}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    if (response.status === 204) {
      return;
    }
    let errorDetail = `サーバーエラー: ${response.status}`;
    try {
      const errorJson = await response.json();
      errorDetail = errorJson.detail || errorDetail;
    } catch (e) {
      errorDetail = (await response.text()) || errorDetail;
    }
    throw new Error(errorDetail);
  }
};
